import { CREATE_PROJECT_DISTRIBUTION_SUCCESS } from "../tableSection/distributionTable/redux/constants";
import { CREATE_PROJECT_REVISIONS_SUCCESS } from "../tableSection/revisions/redux/constants";
import * as constants from "./constants";

const initialPermissions = {
  document_control: {
    add_edit: false,
    view: false,
    export: false,
    delete: false,
  },
  distribution: { add_edit: false, view: false, delete: false },
  revisions: { add_edit: true, view: true, delete: true },
};

const initialState = {
  docTypeGrpahData: [],
  allMaterialControl: [],
  fetchingLoading: true,
  fetchDocsLoading: true,
  updateLoading: false,
  totalRecords: 0,
  deleteAttachLoading: false,
  isAddImsDoc: false,
  isUpdateImsDoc: false,
  deletingLoading: false,
  totalAndCompleted: [],
  permissions: initialPermissions,
  currentMaterialControl: null,
  newMaterialControl: null,
  fetchingMaterialControlById: false,
  openMainForm: false,
  mainFormType: null,
  mainFormRecord: null,
  closeMainForm: false,
  // Project completion data state
  completionData: null,
  fetchingCompletionData: false,
  projectId: null,
};

const ProjectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_MATERIAL_CONTROL:
      return {
        ...state,
        fetchDocsLoading: true,
        permissions: initialPermissions,
        isAddImsDoc: false,
        isUpdateImsDoc: false,
      };
    case constants.FETCH_MATERIAL_CONTROL_SUCCESS:
      // Handle the API response structure properly
      let documents = [];
      let total_documents = 0;
      
      // Check if the response has a data property (common API structure)
      if (action.data && action.data.data) {
        documents = action.data.data;
        total_documents = action.data.total || documents.length;
      } else {
        // Fallback to the old structure
        documents = Array.isArray(action.data) ? action.data : [];
        total_documents = Array.isArray(action.data) ? action.data.length : 0;
      }
            
      return {
        ...state,
        fetchDocsLoading: false,
        allMaterialControl: documents,
        totalRecords: total_documents,
        permissions: initialPermissions,
      };
    case constants.FETCH_MATERIAL_CONTROL_ERROR:
      return {
        ...state,
        fetchDocsLoading: false,
      };

    case constants.CREATE_MATERIAL_CONTROL:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_MATERIAL_CONTROL_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allMaterialControl: [action.data, ...state.allMaterialControl],
        isAddImsDoc: false,
        isUpdateImsDoc: false,
        closeMainForm: action.closeMainForm,
        openMainForm: false,
      };
    case constants.CREATE_MATERIAL_CONTROL_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAddImsDoc: false,
        isUpdateImsDoc: false,
      };
      
    case constants.UPDATE_MATERIAL_CONTROL:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_MATERIAL_CONTROL_SUCCESS:
      // Update the record in the allMaterialControl array
      const updatedMaterialControls = state.allMaterialControl.map((item) =>
        item.id === action.data.id ? { ...item, ...action.data } : item
      );
      return {
        ...state,
        allMaterialControl: updatedMaterialControls,
        updateLoading: false,
        isAddImsDoc: false,
        isUpdateImsDoc: false,
        closeMainForm: false,
        openMainForm: false,
      };
    case constants.UPDATE_MATERIAL_CONTROL_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAddImsDoc: false,
        isUpdateImsDoc: false,
      };

    case constants.FETCH_PROJECT_ACTIVITIES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_PROJECT_ACTIVITIES_SUCCESS:
      const { completed, total, ...rest } = action.data;

      let totalAndCompleted = [
        {
          label: "",
          id: 1,
          Completed: completed,
          Total: total,
        },
      ];

      let result = [];

      Object.entries(rest).map((el, i) =>
        result.push({
          Completed: el[1].completed_by_template,
          id: i + 1,
          label: el[0],
          Total: el[1].total_by_template,
        })
      );

      return {
        ...state,
        fetchingLoading: false,
        docTypeGrpahData: result,
        totalAndCompleted,
      };
    case constants.FETCH_PROJECT_ACTIVITIES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };
    case constants.UPDATE_PROJECT_ACTIVITY:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_PROJECT_ACTIVITY_SUCCESS:
      const updated = state.allMaterialControl.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allMaterialControl: updated,
        updateLoading: false,
        isAddImsDoc: false,
        isUpdateImsDoc: false,
      };
    case constants.UPDATE_PROJECT_ACTIVITY_ERROR:
      return {
        ...state,
        updateLoading: false,
      };
    case constants.DELETE_MATERIAL_CONTROL:
      return {
        ...state,
        deletingLoading: true,
      };
    case constants.DELETE_MATERIAL_CONTROL_SUCCESS:
      const updatedAct = state.allMaterialControl.filter((el) => el.id !== action.data.id);
      return {
        ...state,
        allMaterialControl: updatedAct,
        deletingLoading: false,
      };
    case constants.DELETE_MATERIAL_CONTROL_ERROR:
      return {
        ...state,
        deletingLoading: false,
      };
    case constants.DELETE_PROJECT_DOC_ATTACH:
      return {
        ...state,
        deleteAttachLoading: true,
      };
    case constants.DELETE_PROJECT_DOC_ATTACH_SUCCESS:
      const {
        recordId,
        imgItem: { id },
      } = action.data;

      let updatedActivities = [];

      state.allMaterialControl.map((el) => {
        if (el.id === recordId) {
          let document_attachments = el.document_attachments.filter(
            (img) => img.id != id
          );
          updatedActivities.push({ ...el, document_attachments });
        } else {
          updatedActivities.push(el);
        }
      });

      return {
        ...state,
        allMaterialControl: updatedActivities,
        deleteAttachLoading: false,
      };
    case constants.UPDATE_PROJECT_ISADD_ISUPDATE:
      const { isAddImsDoc, isUpdateImsDoc } = action.data;
      return {
        ...state,
        isAddImsDoc,
        isUpdateImsDoc,
      };
    case constants.DELETE_PROJECT_DOC_ATTACH_ERROR:
      return {
        ...state,
        deleteAttachLoading: false,
      };

    case constants.FETCH_PROJECT_BATCH_UPDATE:
      return {
        ...state,
        fetchDocsLoading: true,
      };
    case constants.FETCH_PROJECT_BATCH_UPDATE_SUCCESS:
      return {
        ...state,
        fetchDocsLoading: false,
        allMaterialControl: action.data.documents,
        totalRecords: action.data.total_documents,
      };
    case constants.FETCH_PROJECT_BATCH_UPDATE_ERROR:
      return {
        ...state,
        updateLoading: false,
      };
      
    case constants.FETCH_MATERIAL_CONTROL_BY_ID:
      return {
        ...state,
        fetchingMaterialControlById: true,
        currentMaterialControl: null,
      };
    case constants.FETCH_MATERIAL_CONTROL_BY_ID_SUCCESS:
      return {
        ...state,
        fetchingMaterialControlById: false,
        currentMaterialControl: action.data,
        newMaterialControl: action.data,
      };
    case constants.FETCH_MATERIAL_CONTROL_BY_ID_ERROR:
      return {
        ...state,
        fetchingMaterialControlById: false,
        currentMaterialControl: null,
        newMaterialControl: null,
      };
      
    case constants.RESET_NEW_MATERIAL_CONTROL:
      return {
        ...state,
        newMaterialControl: null,
      };
      
    case constants.MARK_ITEM_AS_RECEIVED_SUCCESS:
      // Update the current material control if it matches the updated item
      if (state.currentMaterialControl && state.currentMaterialControl.id === action.data.materialControlRegisterId) {
        const updatedMaterialControl = {
          ...state.currentMaterialControl,
          progressSteps: state.currentMaterialControl.progressSteps.map(step => {
            // If this is the fabrication step (index 0), update it with the new data
            if (step.type === 'fabrication') {
              return {
                ...step,
                ...action.data,
                status: 'received'
              };
            }
            return step;
          })
        };
        
        return {
          ...state,
          currentMaterialControl: updatedMaterialControl
        };
      }
      return state;
      
    case constants.MARK_ITEM_AS_COMPLETED_SUCCESS:
      // Update the current material control if it matches the updated item
      if (state.currentMaterialControl && state.currentMaterialControl.id === action.data.materialControlRegisterId) {
        const updatedMaterialControl = {
          ...state.currentMaterialControl,
          progressSteps: state.currentMaterialControl.progressSteps.map(step => {
            // If this is the fabrication step and it matches the progressStepId, update it
            if (step.id === action.data.id) {
              return {
                ...step,
                ...action.data
              };
            }
            return step;
          })
        };
        
        return {
          ...state,
          currentMaterialControl: updatedMaterialControl
        };
      }
      return state;
    case CREATE_PROJECT_REVISIONS_SUCCESS:
      const { document_control_id, rev } = action.data;

      let updatedDocs = state.allMaterialControl.map((el) => {
        let updated = {
          latest_revision: rev,
          doc_revisions: [...el.doc_revisions, action.data],
        };

        return el.id === document_control_id ? { ...el, ...updated } : el;
      });

      return {
        ...state,
        allMaterialControl: updatedDocs,
      };
    case CREATE_PROJECT_DISTRIBUTION_SUCCESS:
      const { data } = action;
      let updatedDocumentss = state.allMaterialControl.map((el) => {
        let updatedDis = [...el.doc_distributions, action.data];

        return el.id === data.document_control_id
          ? { ...el, doc_distributions: updatedDis }
          : el;
      });
      return {
        ...state,
        allMaterialControl: updatedDocumentss,
      };

    case constants.OPEN_MAIN_FORM:
      return {
        ...state,
        openMainForm: true,
        mainFormType: action.payload.type,
        mainFormRecord: action.payload.record,
      };
    case constants.RESET_OPEN_MAIN_FORM:
      return {
        ...state,
        openMainForm: false,
        closeMainForm: false,
      };
      
    // Project completion data cases
    case constants.FETCH_PROJECT_COMPLETION_DATA:
      return {
        ...state,
        fetchingCompletionData: true,
        projectId: action.data.projectId,
      };
    case constants.FETCH_PROJECT_COMPLETION_DATA_SUCCESS:
      return {
        ...state,
        fetchingCompletionData: false,
        completionData: action.data,
      };
    case constants.FETCH_PROJECT_COMPLETION_DATA_ERROR:
      return {
        ...state,
        fetchingCompletionData: false,
      };

    default:
      return state;
  }
};

export default ProjectsReducer;
